import styled from 'styled-components';

/**
 * DashboardLayout Components
 *
 * Reusable layout components for pages with sidebars.
 * Creates a responsive two-column layout that stacks on mobile.
 *
 * Usage:
 * import { DashboardLayout, MainContent, Sidebar } from 'components/DashboardLayout';
 *
 * <DashboardLayout>
 *   <MainContent>
 *     <Card>Main content here</Card>
 *   </MainContent>
 *   <Sidebar>
 *     <Card>Sidebar content</Card>
 *     <QuickActions ... />
 *   </Sidebar>
 * </DashboardLayout>
 */

// Main dashboard grid layout - 2 columns with sidebar
export const DashboardLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr ${(props) => props.sidebarWidth || '300px'};
  gap: ${(props) => props.gap || '30px'};

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`;

// Main content area (left column)
export const MainContent = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.gap || '24px'};
`;

// Sidebar area (right column)
export const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.gap || '20px'};
`;

export default {
  DashboardLayout,
  MainContent,
  Sidebar,
};
